import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';

@Component({
  selector: 'app-onboarding-comments-icon',
  standalone: true,
  imports: [LinkComponent],
  templateUrl: './onboarding-comments-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './onboarding-comments-icon.component.scss'
})
export class OnboardingCommentsIconComponent {
  hasUnreadMessages = input<boolean>(false);
  disabled = input<boolean>(false);
  clicked = output();

  click() {
    this.clicked.emit();
  }
}
